import moment from "moment";
import React, { useState, useEffect } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  setValue,
  removeLast,
  addRow,
} from "../../common/FormCreatorV2/helpers";
import { allFieldsFilled } from "../../helpers/form";
import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import HorizontalLine from "../../common/HorizontalLine";
import { postABMForms } from "../../redux/actions/abmActions";

const WorkHistoryForm = ({ appData, postABMFormFunc }) => {
  let initialData = {};

  if (appData.abmOnboarding && appData.abmOnboarding.workhistory) {
    initialData = {
      ...initialData,
      ...appData.abmOnboarding.workhistory,
    };
  }

  const refInitObj = {
    "Contact Name": "",
    Address: "",
    Postcode: "",
    "Mobile Number": "",
    "Email Address": "",
    "Relation to you": "",
    "How long have you known the referee?": "",
  };

  let initialRefState = [refInitObj];

  if (
    appData &&
    appData.abmOnboarding &&
    appData.abmOnboarding.workhistory &&
    appData.abmOnboarding.workhistory.refState
  ) {
    initialRefState = Object.keys(
      appData.abmOnboarding.workhistory.refState
    ).map((key) => appData.abmOnboarding.workhistory.refState[key]);
  }

  let initialWorkHistory = [
    {
      "Type of Referee": "",
      "Company/Educational/Agency Name": "",
      "Contact Name": "",
      "Contact Job Title": "",
      "Start Date (month and year)": "",
      "End Date (month and year)": "",
      "Company Address": "",
      "Mobile Number": "",
      "Daytime Phone Number": "",
      "Email Address": "",
    },
  ];

  const getVal = getField(initialData);

  const [shouldDisable, setShouldDisable] = useState(false);

  const repeatedDisable = [false];
  const [refState, setRefState] = useState(initialRefState);

  const repeatedContent = [
    {
      setValue: setValue(refState, setRefState),
      removeLast: removeLast(refState, setRefState),
      state: refState,
      setState: setRefState,
      add: addRow(refState, setRefState, refInitObj),
      mandatory: false,
    },
  ];

  const initialErrorMessages = [
    {
      toAfterFromDate: "",
      tooBigGap: "",
      keepOrder: "",
    },
  ];

  if (
    appData.abmOnboarding &&
    appData.abmOnboarding.workhistory &&
    appData.abmOnboarding.workhistory.workHistoryData
  ) {
    initialWorkHistory = Object.keys(
      appData.abmOnboarding.workhistory.workHistoryData
    ).map((key) => appData.abmOnboarding.workhistory.workHistoryData[key]);
  }

  const [workHistoryData, setWorkHistoryData] = useState(initialWorkHistory);
  const [validationErrorMessage, setValidationErrorMessage] =
    useState(initialErrorMessages);
  const [xYearsErrorMessage, setxYearsErrorMessage] = useState("");

  const setValueWork = (value, key, i) => {
    const mappedHistoryData = workHistoryData.map((el, index) => {
      if (i === index) {
        return { ...el, [key]: value };
      }
      return el;
    });

    setWorkHistoryData(mappedHistoryData);
  };

  const removeLastWork = () => {
    const newArr = [...workHistoryData];
    newArr.splice(newArr.length - 1);
    setWorkHistoryData(newArr);
  };

  useEffect(() => {
    let areAllFieldsFilled = true;
    let areErrorMessagesEmpty = true;

    const validationMessages = workHistoryData.map(() => ({}));

    areAllFieldsFilled = allFieldsFilled(workHistoryData, [
      "Daytime Phone Number",
    ]); // check if there are no empty values

    if (
      workHistoryData[0]["End Date (month and year)"] &&
      workHistoryData[0]["Start Date (month and year)"]
    ) {
      let oldestDate = moment(
        workHistoryData[0]["End Date (month and year)"]
      ).format("YYYY-MM-DD");
      let earliestDate = moment(
        workHistoryData[0]["Start Date (month and year)"]
      ).format("YYYY-MM-DD");

      workHistoryData.forEach((el, i) => {
        const from = el["Start Date (month and year)"]
          ? moment(el["Start Date (month and year)"]).format("YYYY-MM-DD")
          : null;
        const to = el["End Date (month and year)"]
          ? moment(el["End Date (month and year)"]).format("YYYY-MM-DD")
          : null;

        // Validation if 'from' date is before 'to' date validation
        if (from && to && moment(to).isBefore(from)) {
          const prev = validationMessages[i] ? validationMessages[i] : {};
          validationMessages[i] = {
            ...prev,
            toAfterFromDate: "End date can not be after Start date",
          };
        }

        if (from && moment(from).isBefore(oldestDate)) {
          oldestDate = from;
        }

        if (to && moment(to).isAfter(earliestDate)) {
          earliestDate = to;
        }
      });
    }

    // Validation difference in time between jobs (max 28 days)
    for (let i = 0; workHistoryData.length - 1; i += 1) {
      if (i === workHistoryData.length - 1) {
        break;
      }
      if (
        workHistoryData[i + 1]["Start Date (month and year)"] &&
        workHistoryData[i + 1]["End Date (month and year)"] &&
        workHistoryData[i]["Start Date (month and year)"] &&
        workHistoryData[i]["End Date (month and year)"]
      ) {
        const start = moment(
          workHistoryData[i + 1]["End Date (month and year)"],
          "YYYY/MM/DD"
        );
        const end = moment(
          workHistoryData[i]["Start Date (month and year)"],
          "YYYY/MM/DD"
        );
        const r = moment(end).diff(moment(start), "days", true);
        if (r > 28) {
          const startDESC = moment(
            workHistoryData[i]["End Date (month and year)"],
            "YYYY/MM/DD"
          );
          const endDESC = moment(
            workHistoryData[i + 1]["Start Date (month and year)"],
            "YYYY/MM/DD"
          );
          const rDESC = moment(endDESC).diff(moment(startDESC), "days", true);

          if (r > 28 || rDESC > 28) {
            const prev = validationMessages[i + 1]
              ? validationMessages[i + 1]
              : {};
            validationMessages[i + 1] = {
              ...prev,
              tooBigGap:
                "You have a gap of more than 28 days in comparison with the last job you entered, please amend as we can not accept a gap of more than 28 days without details of a character reference to contact.",
              keepOrder:
                "Please ensure your work history is in chronological order so we can validate your dates.",
            };
          }
        }
      }
    }

    validationMessages.forEach((el) => {
      Object.keys(el).forEach((key) => {
        if (el[key] && Object.keys(el[key]).length > 0) {
          areErrorMessagesEmpty = false;
        }
      });
    });

    setValidationErrorMessage(validationMessages);

    if (
      areAllFieldsFilled &&
      areErrorMessagesEmpty &&
      xYearsErrorMessage === ""
    ) {
      setShouldDisable(false);
    } else {
      setShouldDisable(true);
    }
  }, [shouldDisable, workHistoryData, xYearsErrorMessage]);

  const initialState = {
    Blurb: {
      htmlObj: (
        <div>
          <HorizontalLine
            text={
              "Reference Guideline - Employment and Education History Details"
            }
          />
          <span style={{ color: "red" }}>
            Provide information of your full five-year history from the date of
            filling your application, i.e. if today’s date is 01/01/2021 –
            please confirm your employment/education references from 01/01/2016
            to 01/01/2021.
          </span>
          <br />
          <br />
          <b>
            Five Year Employment / Educational / Unemployment History – Types of
            References
          </b>
          <br />
          <br />
          <b>Employment </b>– Directly employed by the company. Please provide
          details of the HR department or a company employee authorised to
          complete reference requests.
          <br />
          <br />
          <b>Voluntary work </b>- No financial gain involved for the individual,
          i.e. work experience. Please provide details of someone in HR or
          otherwise authorised employee to complete reference requests.
          <br />
          <br />
          <b>Agency </b>– If you have been registered at an agency. Provide the
          details of someone who is authorised to complete reference requests on
          the agency behalf.
          <br />
          <br />
          <b>Educational </b>– Please provide the details of any educational
          establishments you have studied at in the past 5 years, this includes,
          Secondary schools, Colleges and Universities. We will need the contact
          details of either student records or the Admin team authorised by the
          educational establishment to complete the request.
          <br />
          <br />
          <b>Self-Employment </b>– Provide the details of your accountant, if
          you didn’t have one then you need to contact HMRC on 0300 200
          3505/3300 and request them to send you a letter with details of your
          self-employment, this must be confirmed as dd/mm/yy, when calling HMRC
          they will need to confirm income for each year, if they are unable to
          confirm income, we will need copies of each year’s tax returns.
          <br />
          <br />
          <b>Job Centre </b>– If you have received claims over the last 5 years
          then provide what type of benefit you were claiming and that dates of
          claim in the format of dd/mm/yy.
          <br />
          <br />
          <b>Gap </b>– This is where you have been unemployed for more than 28
          days, so this could be school holidays, looking after children, been
          made redundant and looking for work etc. We need to confirm:
          <br />
          <br />
          <b>- What</b> you were doing for the period being covered – if
          travelling we will require proof of travel, itinerary, tickets,
          passport stamps etc. If looking after children we will require copies
          of birth certificates.
          <br />
          <br />
          <b>- Where</b> you were residing – at what address etc.
          <br />
          <br />
          <b>- How</b> you were supported – savings, parents, family etc.
          <br />
          <br />
          Your gap referee must not be a blood relative, current or ex relatives
          by marriage, relatives by adoption - including cousins, current or ex
          partners and their relatives, persons living at the same address, be
          current employees of the ID Pass Sponsoring Company or individuals
          under the age of 16 years.
        </div>
      ),
    },
    WorkHistory2: {
      type: "workHistoryV2",
      workHistoryColumns: [
        {
          title: "Type of Referee",
          type: "text",
          mandatory: "true",
          format: "",
        },
        {
          title: "Company/Educational/Agency Name",
          type: "text",
          mandatory: "true",
          format: "",
        },
        { title: "Contact Name", type: "text", mandatory: "true", format: "" },
        {
          title: "Contact Job Title",
          type: "text",
          mandatory: "true",
          format: "",
        },
        {
          title: "Start Date (month and year)",
          type: "date",
          mandatory: "true",
          format: "month",
        },
        {
          title: "End Date (month and year)",
          type: "date",
          mandatory: "true",
          format: "month",
        },
        {
          title: "Company Address",
          type: "text",
          mandatory: "true",
          format: "",
        },
        { title: "Mobile Number", type: "text", mandatory: "true", format: "" },
        {
          title: "Daytime Phone Number",
          type: "text",
          mandatory: "",
          format: "",
        },
        { title: "Email Address", type: "text", mandatory: "true", format: "" },
      ],
      initialWorkHistory: {
        "Type of Referee": "",
        "Company/Educational/Agency Name": "",
        "Contact Name": "",
        "Contact Job Title": "",
        "Start Date (month and year)": "",
        "End date": "",
        "Company Address": "",
        "Mobile Number": "",
        "Daytime Phone Number": "",
        "Email Address": "",
      },
    },
    WorkHistory3: {
      title: "Personal/Gap Reference Details",
      type: "heading",
      textDescription: [],
    },
    WorkHistory4: {
      type: "repeated",
      maxTableRowLength: 2,
      rowTitle: "Reference",
      tableDetails: {
        columns: [
          "Contact Name",
          "Address",
          "Postcode",
          "Mobile Number",
          "Email Address",
          "Relation to you",
          "How long have you known the referee?",
        ],
      },
      tableNumOfMandatoryRows: "2",
      repeatedIndex: 0,
    },
    WorkHistory5: {
      title: "Self-Employment Details",
      type: "heading",
      textDescription: [],
    },
    WorkHistory6: {
      title: "Accountant Company Name",
      value: getVal("WorkHistory6"),
      type: "text",
      mandatory: false,
    },
    WorkHistory7: {
      title: "Accountant Name",
      value: getVal("WorkHistory7"),
      type: "text",
      mandatory: false,
    },
    WorkHistory8: {
      title: "Contact Job Title",
      value: getVal("WorkHistory8"),
      type: "text",
      mandatory: false,
    },
    WorkHistory9: {
      title: "Start Date (month and year)",
      value: getVal("WorkHistory9"),
      type: "text",
      mandatory: false,
    },
    WorkHistory10: {
      title: "End Date",
      value: getVal("WorkHistory10"),
      type: "text",
      mandatory: false,
    },
    WorkHistory11: {
      title: "Company Address",
      value: getVal("WorkHistory11"),
      type: "text",
      mandatory: false,
    },
    WorkHistory12: {
      title: "Mobile Number",
      value: getVal("WorkHistory12"),
      type: "text",
      mandatory: false,
    },
    WorkHistory13: {
      title: "Daytime Phone Number",
      value: getVal("WorkHistory13"),
      type: "text",
      mandatory: false,
    },
    WorkHistory14: {
      title: "Email Address",
      value: getVal("WorkHistory14"),
      type: "text",
      mandatory: false,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postABMFormFunc("workhistory", {
      ...fieldValuesPayload,
      workHistoryData,
      refState,
    });

    history.push("/profile/edit/ABM-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Five Year Work History"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit} // handles save to JSON
      handleCancel={() => history.push("/profile/edit/ABM-onboarding")}
      onboardingBranch={"ABM"}
      workHistoryData={workHistoryData}
      workValidationErrorMessage={validationErrorMessage}
      shouldDisable={shouldDisable}
      setValue={setValueWork}
      xYearsWorkErrorMessage={xYearsErrorMessage}
      removeLast={removeLastWork}
      setWorkHistoryData={setWorkHistoryData}
      repeatedSetValue={setValue(refState, setRefState)}
      repeatedRemoveLast={removeLast(refState, setRefState)}
      repeatedState={refState}
      repeatedSetState={setRefState}
      repeatedAdd={addRow(refState, setRefState, refInitObj)}
      repeatedContent={repeatedContent}
      repeatedDisable={repeatedDisable}
    />
  );
};

WorkHistoryForm.propTypes = {
  appData: any,
  postABMFormFunc: func,
};

const mapDispatchToProps = {
  postABMFormFunc: postABMForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(WorkHistoryForm);
